// extracted by mini-css-extract-plugin
export default {"onAccountPaymentBadge":"OnAccountPaymentBadge_onAccountPaymentBadge__MqT9H"};